import { CustomerReference } from "../../../../api-clients/composition";
import "./cards.scss";

import React, {  useContext, useEffect, useState } from "react";

export interface CustomerCardProps {
  customer: CustomerReference;
}

let lastCustomerId:string = '';

const CustomerCard = React.memo(( { customer }: CustomerCardProps) => {
  const { address = "", firstName = "", insights = "" , lastName = ""  } = customer || {};
  const [typedText, setTypedText] = useState<string>('');

  useEffect(() => {
    let typePosition: number = 0;
    let timer;

    function typeWriter() {
      const typewriterElement = document.getElementById("typewriter");

      if (typePosition < insights.length && typewriterElement) {
        typewriterElement.innerHTML += insights.charAt(typePosition);
        typePosition++;
        timer = setTimeout(typeWriter, 60); // Adjust typing speed
      }
    }

    // avoid re-typing when page attempts to fully refresh same view
    if (customer.id !== lastCustomerId) {
      lastCustomerId = customer.id;
      typeWriter();
    }
    else {
      setTypedText(insights);
    }
    return () => {
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handleCustomerDetails = () => {
  };

  const handleAddToList = () => {
  };

  return (
    <div className="ai-card">
      <div className="customerCardHeader">
        <h3 className="customerName">
          {firstName} {lastName}
        </h3>
        <i className="ico-mmi-add-to-list headerIconButton" onClick={handleAddToList}></i>
      </div>
      <p className="customerEmail">{address}</p>
      <p className="customerInsights" id="typewriter">{typedText}</p>
      <button className="primaryButton" onClick={handleCustomerDetails}>
        View Profile
      </button>
    </div>
  );
});

export default CustomerCard;
